/**
 * The vocabulary both shells share for the act-as hand-off: the admin shell
 * opens the client shell as another user, and the client shell asks for it on
 * every request. These mirror the API's own names — `IMPERSONATION_HEADER` and
 * `PlatformRole` in `@vasta/backend-core-authentication`, the error codes in
 * `@vasta/backend-core-errors` — which the frontend cannot import across the
 * stack boundary.
 */

/** Carries `users.id` — the local identifier the admin list shows. */
export const IMPERSONATION_HEADER = 'x-impersonate-user-id';

/** How the admin shell hands the target user over. */
export const IMPERSONATION_QUERY_PARAM = 'impersonateUserId';

/** The role that may act as somebody else. */
export const PLATFORM_ADMIN_ROLE = 'platform-admin';

/**
 * The API's refusals that end the hand-off: the caller may not impersonate,
 * the route is closed to an impersonated session, or the target is unusable.
 * The tab drops its state and reloads as the caller.
 */
export const IMPERSONATION_REFUSALS: ReadonlySet<string> = new Set([
  'IMPERSONATION_FORBIDDEN',
  'IMPERSONATION_ROUTE_BLOCKED',
  'IMPERSONATION_TARGET_NOT_FOUND',
  'IMPERSONATION_SELF',
]);
